import P from './P'
import Prompts from './Prompts'
import Q from './Q'
import R from './R'
import S from './S'

Prompts.P = P
Prompts.Q = Q
Prompts.R = R
Prompts.S = S

export default Prompts



// WEBPACK FOOTER //
// ./src/components/Prompts/index.js